import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  IRecommendedPricesResponse,
  IRecommendedPricesTargeting
} from '@/apps/traforama/interfaces/recomendedPrices'

export const fetchItems = async (
  campaignId: number
): Promise<IRecommendedPricesResponse> => {
  const params = Object.assign(
    { limit: 3000, start: 0 },
    nestedQueryFormatter('filter', { campaign_id: campaignId }, false)
  )
  const response = await apiClient.get<IRecommendedPricesResponse>(
    '/recomended_prices',
    { params }
  )
  return response.data
}

export const fetchItemsByTargeting = async (
  targeting: IRecommendedPricesTargeting
): Promise<IRecommendedPricesResponse> => {
  const params = Object.assign(
    { limit: 3000, start: 0 },
    nestedQueryFormatter('filter', targeting, false)
  )
  const response = await apiClient.get<IRecommendedPricesResponse>(
    '/recomended_prices',
    { params }
  )
  return response.data
}
